import { Pipe } from '@angular/core';
import { MediaSourcesPipe } from '@spartacus/storefront';

@Pipe({
  name: 'cxMediaSources',
  standalone: false,
})
export class CustomMediaSourcesPipe extends MediaSourcesPipe {}
